import Vue from 'vue';

Vue.mixin({
  methods: {
    clickConfirm(clickConfirm, message = '本当に削除してもよろしいですか？') {
      if (confirm(message)) {
        clickConfirm();
      }
    },
  },
});
